'use strict';

// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = require('es-object-atoms/ToObject');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2023/ToObject.js
 ** module id = 920
 ** module chunks = 0
 **/